let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5gcab")).then(() => parcelRequire('8ee8O'));